// eslint-disable-next-line no-unused-vars
import React from 'react';
import { arrayOf, bool, func, object } from 'prop-types';
import { Checkbox } from '@carbon/react';
import { useTranslation } from 'react-i18next';

import FilterListComponent from 'Components/Filters/FilterListComponent';

const BrandsComponent = (
  { brands = [], filterValues = [], onSearch, open, onToggle, onChange, selected = [] }
) => {
  const { t } = useTranslation();

  if (!brands.length) {
    return null;
  }

  return (
    <FilterListComponent
      filterTitle={ t('filters.brands') }
      onToggle={ onToggle }
      onSearch={ onSearch }
      cx={ open ? 'open' : 'closed' }
      showSearch={ brands.length > 10 }
    >
      <div className="options">
        { filterValues.map(brand => (
          <div className="filterItem" key={ brand.id }>
            <Checkbox
              id={ brand.id }
              name={ brand.name }
              labelText={ brand.name }
              checked={ (selected || []).findIndex(i => i.id === brand.id) >= 0 }
              onChange={ (_, { checked }) => onChange(brand)(checked) }
            />
            { ('count' in brand) && (<span className="count">({ brand.count })</span>) }
          </div>
        )) }
      </div>
    </FilterListComponent>
  );
};

BrandsComponent.propTypes = {
  brands: arrayOf(object),
  onChange: func,
  onToggle: func,
  onSearch: func,
  open: bool,
  filterValues: arrayOf(object),
  selected: arrayOf(object)
};

export default BrandsComponent;
